import VerificationPros from "../VerificationPros/VerificationPros.jsx";

export default VerificationPros;

